import { Button, Chip, Grid, Paper, Stack, Typography } from "@mui/material"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
// Icon
import DeleteIcon from '@mui/icons-material/Delete'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import { brlCurrencyToLabel } from "../../../../../../../utils"

export const RecorteRendaMensalFilterPreview = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Hook
    const { removeCreateRecorteFormFiltros } = useRecortesExtracaoService()

    return (
        <>
            <Grid item container xs={6} spacing={2} mb={2}>
                <Paper elevation={3} sx={{ padding: 2, width: '100%' }}>
                    <Grid item xs={12} container justifyContent={'space-between'} alignItems="center" my={1}>
                        <Grid item>
                            <Typography
                                variant="body1"
                                color="primary"
                                fontWeight="bold"
                                textTransform="uppercase"
                                mr={2}
                            >
                                Renda Presumida Mensal
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="outlined"
                                startIcon={<DeleteIcon />}
                                onClick={() => removeCreateRecorteFormFiltros({ filtro: 'rendaPresumidaMensal' })}
                            >
                                Remover filtro
                            </Button>
                        </Grid>
                    </Grid>

                    {createRecorteExtracaoForm.fields.Filtros &&
                        createRecorteExtracaoForm.fields.Filtros.rendaPresumidaMensal && (
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    flexWrap="wrap"
                                >
                                    {createRecorteExtracaoForm.fields.Filtros.rendaPresumidaMensal.min &&
                                        <Chip
                                            key={0}
                                            icon={<MonetizationOnIcon />}
                                            label={`de: R$ ${brlCurrencyToLabel(createRecorteExtracaoForm.fields.Filtros.rendaPresumidaMensal.min)}`}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    }
                                    {createRecorteExtracaoForm.fields.Filtros.rendaPresumidaMensal.max &&
                                        <Chip
                                            key={1}
                                            icon={<MonetizationOnIcon />}
                                            label={`até: R$  ${brlCurrencyToLabel(createRecorteExtracaoForm.fields.Filtros.rendaPresumidaMensal.max)}`}
                                            sx={{
                                                m: 0.5
                                            }}
                                        />
                                    }
                                </Stack>
                            </Grid>
                        )}
                </Paper>
            </Grid>
        </>
    )
}